import { Title as Title$1 } from '@10d/tend-ui-typography';
import React from 'react';

const Title = ({ children }) => {
    return (React.createElement(Title$1, { level: 'h5', margin: 0 }, children));
};
Title.displayName = 'Drawer.Title';

export { Title };
//# sourceMappingURL=Title.js.map
